var _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _animateMotion, _tspan6, _animateMotion2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "loader",
    overflow: "hidden",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsEv: "http://www.w3.org/2001/xml-events",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("text", {
    style: {
      whiteSpace: "pre-wrap"
    },
    fontFamily: "'Andale Mono'",
    fontSize: "1.1em",
    fill: "#00FF00",
    x: 0,
    y: -3
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: -200,
    dy: "1.12em"
  }, "01010000 01101100 01010000 01101100")), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: -200,
    dy: "1.12em"
  }, "01110111 01100001 01110111 01100001")), _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: -200,
    dy: "2.24em"
  }, "01110111 01100001 01110111 01100001")), _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: -200,
    dy: "1.12em"
  }, "01010000 01101100 01010000 01101100")), _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: -200,
    dy: "1.12em"
  }, "01110111 01100001 01110111 01100001")), _animateMotion || (_animateMotion = /*#__PURE__*/React.createElement("animateMotion", {
    from: "0,0",
    to: "190, 0",
    dur: "5s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("text", {
    style: {
      whiteSpace: "pre-wrap"
    },
    fontFamily: "'Andale Mono'",
    fontSize: "1.1em",
    fill: "#00FF00",
    x: 0,
    y: -3
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    dy: "3.36em"
  }, "-PLEASE- --WAIT-- -PLEASE- --WAIT--")), _animateMotion2 || (_animateMotion2 = /*#__PURE__*/React.createElement("animateMotion", {
    from: "0,0",
    to: "-190, 0",
    dur: "5s",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.d83c11a3993d1bd50b31db2cec2b6ecb.svg";
export { ForwardRef as ReactComponent };